import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/designs`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const designsApi = {
  async getDesigns(payload) {
    return apiCall({
      url: `${BASE_URL}/paginated`,
      method: "POST",
      data: payload
    });
  },
  async deleteDesign(id) {
    return apiCall({
      url: `${BASE_URL}/delete/${id}`,
      method: "DELETE",
    });
  },
};

export const urlMakePageFetcherDesigns = {
  url: `${BASE_URL}/paginated`,
  method: "POST"
};

export { withQuery };
